import { Button, SvgIconNames } from '@toggle/design-system';
import React from 'react';

import * as S from './MenuBarV2.styles';

interface MenuBarV2Item {
  id: ChartMenuBarV2Ids;
  iconName: SvgIconNames;
}

export interface MenuBarV2Locales {
  addData: string;
  marketLeadingIndicators: string;
  events: string;
}

interface MenuBarV2Props {
  onPrimarySearch: () => void;
  onMenuItemClick: (id: ChartMenuBarV2Ids) => void;
  disabledItems: boolean;
  children?: React.ReactNode;
  locales: MenuBarV2Locales;
}

export type ChartMenuBarV2Ids = 'marketLeadingIndicators' | 'events';

export const MenuBarV2 = ({
  onPrimarySearch,
  onMenuItemClick,
  disabledItems,
  children,
  locales,
}: MenuBarV2Props) => {
  const items: MenuBarV2Item[] = [
    {
      id: 'marketLeadingIndicators',
      iconName: 'Indicators',
    },
    {
      id: 'events',
      iconName: 'Rating',
    },
  ];

  return (
    <S.MenuBarRoot data-testid="menu-bar">
      {children ?? <S.MenuItem>{children}</S.MenuItem>}
      <S.MenuItemSearch>
        <Button
          data-testid="search-button"
          iconName="Add"
          label={locales.addData}
          variant="empty"
          fullWidth
          aria-label={locales.addData}
          onClick={onPrimarySearch}
        />
      </S.MenuItemSearch>
      {items.map(item => (
        <S.MenuItem key={item.iconName}>
          <S.StyledButton
            iconName={item.iconName}
            label={locales[item.id]}
            variant="empty"
            onClick={() => onMenuItemClick(item.id)}
            disabled={disabledItems}
            data-testid={`${item.id}-button`}
          />
        </S.MenuItem>
      ))}
    </S.MenuBarRoot>
  );
};
